export const lang =
    [
        {
            "field1": "",
            "ID": "0",
            "zh-CN": "规则",
            "字节限制": "",
            "备注": "规则页",
            "zh-TW": "規則",
            "en": "Rules",
            "ar": "قواعد",
            "fr": "Règles",
            "de": "Regeln",
            "id": "Aturan",
            "ja": "ルール",
            "ko": "규칙",
            "pt": "Regras",
            "ru": "Правила",
            "es": "Reglas",
            "th": "กฎ",
            "vi": "Luật lệ",
            "it": "Regole",
            "tr": "Kuralları"
        },
        {
            "field1": "",
            "ID": "1",
            "zh-CN": "1. 点击下方图标选择要放置的元素后，点击相应格子进行摆放。 <p></p>\n2. 点击擦除按钮后，可通过点击相应格子清除已摆放元素。 <p></p>\n3. 水晶和怪物出口为必选项，怪物刷新点可以有多个。 <p></p>\n4. 不能将水晶以及怪物出口用障碍物完全堵住。 <p></p>\n5. 水晶周围半径2格，怪物出口周围半径1格内不能放置障碍物。 <p></p>\n6. 活动期间您可以提交多份设计稿，但只会收到一次奖励。当然，如果您的设计图被我们采用，我们会发送额外奖励给您！<p></p>\n7. Habby保留活动的最终解释权。",
            "字节限制": "",
            "备注": "规则页",
            "zh-TW": "1. 點選下方圖示選擇要放置的元素後，點選對應格子進行擺放。 <p></p>\n2. 點選擦除按鈕後，可點選對應格子清除已擺放元素。 <p></p>\n3. 水晶和怪物出口為必選項，怪獸刷新點可以有多個。 <p></p>\n4. 不能將水晶以及怪物出口用障礙物完全堵住。 <p></p>\n5. 水晶周圍半徑2格，怪物出口周圍半徑1格內不能放置障礙物。 <p></p>\n6. 活動期間您可以提交多份設計稿，但只會收到一次獎勵。 當然，如果您的設計圖被我們採用，我們會發送額外獎勵給您！<p></p>\n7. Habby保留活動的最終解釋權。",
            "en": "1. Tap on the bottom icon to choose an element to be placed, then tap on a square of your choice to place it. <p></p>\n2. Tap on the Remove button, then tap on a square to remove a placed element. <p></p>\n3. Crystals and monster exits are mandatory choices. There can be multiple monster spawn points. <p></p>\n4. Crystals and monster exits cannot be sealed off using obstacles. <p></p>\n5. Obstacles cannot be placed within 2 squares of crystals and 1 square of monster exits. <p></p>\n6. During the event, you can submit multiple designs, but will receive your reward once only. Of course, if your maze design is used by us, we will send bonus rewards your way! <p></p>\n7. Habby reserves the right of final interpretation of the event.",
            "ar": "1. اضغط على الأيقونة السفلية لاختيار عنصر ووضعه، ثم اضغط فوق مربع من اختيارك لوضع العنصر فيه. <p></p>\n2. اضغط فوق زر «إزالة»، ثم اضغط فوق مربع لإزالة العنصر الموضوع به. <p></p>\n3. البلورات ومخارج الوحش خيارات إلزامية. يمكن أن يكون هناك العديد من نقاط ظهور الوحوش. <p></p>\n4. لا يمكن إغلاق البلورات ومخارج الوحوش باستخدام العوائق. <p></p>\n5. لا يمكن وضع العوائق داخل 2 مربعات من البلورة و 1 مربعات من مخارج الوحوش. <p></p>\n6. خلال الفعالية، يمكنك إرسال عدة تصاميم، لكنك ستحصل على مكافأتك مرة واحدة فقط. بالطبع، إذا استخدمنا تصميم المتاهة الخاص بك، فسنرسل مكافآت إضافية إليك!<p></p>\n7. تحتفظ شركة Habby بحق الترجمة النهائية للفعالية.",
            "fr": "1. Appuyez sur l'icône du bas pour choisir un élément à placer, puis appuyez sur un carré de votre choix pour le placer.<p></p>\n2. Appuyez sur le bouton Retirer, puis sur un carré pour retirer un élément placé.<p></p>\n3. Les cristaux et les sorties de monstre sont des choix obligatoires. Il peut y avoir plusieurs points d'apparition de monstres.<p></p>\n4. Les cristaux et les sorties de monstres ne peuvent pas être bloquées par des obstacles.<p></p>\n5. Les obstacles ne peuvent pas être placés à moins de 2 cases du Crystal et 1 case des sorties des monstres.<p></p>\n6. Pendant l'événement, vous pouvez envoyer plusieurs designs, mais vous recevrez votre récompense une fois seulement. Bien sûr, si nous utilisons votre design de labyrinthe, nous vous enverrons des récompenses bonus !<p></p>\n7. Habby se réserve le droit d'interpréter définitivement l'événement.",
            "de": "1. Tippe auf das untere Symbol, um ein Element auszuwählen, das du platzieren möchtest – tippe anschließend auf ein Quadrat deiner Wahl, um es zu platzieren.<p></p>\n2. Tippe auf die Entfernen-Schaltfläche und anschließend auf ein Quadrat, um ein platziertes Element zu entfernen.<p></p>\n3. Kristalle und Monsterausgänge sind verpflichtend. Es kann mehrere Monster-Erscheinungspunkte geben.<p></p>\n4. Kristalle und Monsterausgänge können nicht durch Hindernisse versperrt werden.<p></p>\n5. Hindernisse können nicht im Umkreis von 2 Feldern um Kristalle und 1 Feldern um Monsterausgänge platziert werden.<p></p>\n6. Während des Events kannst du mehrere Entwürfe einreichen, aber du erhältst deine Belohnung nur einmal. Wenn dein Labyrinthentwurf von uns genutzt wird, erhältst du natürlich Extrabelohnungen!<p></p>\n7. Habby behält sich das Recht auf die endgültige Auswertung des Events vor.",
            "id": "1. Ketuk ikon bawah untuk memilih unsur yang akan ditempatkan, lalu ketuk petak pilihanmu untuk menempatkannya.<p></p>\n2. Ketuk tombol Hapus, lalu ketuk petak untuk menghapus unsur yang ditempatkan.<p></p>\n3. Kristal dan pintu keluar monster adalah pilihan wajib. Bisa terdapat beberapa titik spawn monster.<p></p>\n4. Kristal dan pintu keluar monster tidak bisa ditutup menggunakan rintangan.<p></p>\n5. Rintangan tidak bisa ditempatkan dalam jarak 2 petak dari kristal dan 1 petak dari pintu keluar monster.<p></p>\n6. Selama event, kamu bisa mengirim beberapa desain, tapi hanya akan menerima hadiahmu sekali saja. Tentu saja, jika desain labirinmu kami gunakan, kami akan mengirim hadiah bonus untukmu!<p></p>\n7. Habby berhak menentukan interpretasi akhir dari event ini.",
            "ja": "1.下方のアイコンをクリックして配置する要素を選択した後、対応するグリッドをクリックして配置します。<p></p>\n2.消去ボタンをクリック後、対応するグリッドをクリックすると、配置した要素を消去することができます。<p></p>\n3.クリスタルとモンスター出口は必須で、モンスターの更新ポイントは複数存在できます。<p></p>\n4.クリスタルとモンスターの出口を障害物で完全にふさぐことはできません。<p></p>\n5.クリスタルの半径2マスとモンスター出口の半径1マス以内に障害物を置くことはできません。<p></p>\n6.イベント期間中、複数件のデザインをご提出いただけますが、報酬の受け取りは1回のみとなります。 もちろん、デザインが採用された場合は追加報酬をお送りします！<p></p>\n7. 本イベントの最終的な解釈はハビーが行うものとします。",
            "ko": "1. 아래 아이콘을 클릭하여 배치할 엘레멘탈을 선택한 후 해당 칸을 클릭하여 배치하세요.<p></p>\n2. 삭제 버튼을 클릭하고 해당 칸을 클릭하면 이미 배치된 엘레멘탈을 삭제할 수 있습니다.<p></p>\n3. 크리스탈과 몬스터 출구는 필수 선택 사항이며, 몬스터 재출현 지점은 여러 개일 수 있습니다.<p></p>\n4. 크리스탈 및 몬스터 출구는 장애물로 완전히 막지 않도록 주의하세요.<p></p>\n5. 크리스탈 주변의 2칸 및 몬스터 출구 주변의 1칸 내에는 장애물을 배치할 수 없습니다.<p></p>\n6. 이벤트 기간동안 여러 디자인을 제출할 수 있지만 보상은 1회만 받을 수 있습니다. 만약 디자인이 채택되고 사용되는 경우 추가 보상을 제공해 드립니다!<p></p>\n7. Habby는 이벤트에 대한 최종 해석권을 보유합니다.",
            "pt": "1. Toque no ícone abaixo para escolher um elemento para posicionar e, então, toque em uma área para posicioná-lo.<p></p>\n2. Toque no botão Remover e, então, toque em uma área para remover um elemento posicionado.<p></p>\n3. Cristais e saídas de monstros são escolhas obrigatórias. Pode ter vários pontos de aparecimento de monstros.<p></p>\n4. Cristais e saídas de monstros não podem ser bloqueados com obstáculos.<p></p>\n5. Não é disponível colocar obstáculos antes de 2 quadrados de distância de cristais e 1 quadrado de distância saídas de monstros.<p></p>\n6. Durante o evento, você pode enviar vários designs, mas receberá sua recompensa apenas uma vez. Claro, se o seu design de labirinto for usado por nós, enviaremos recompensas bônus para você!<p></p>\n7. A Habby se reserva ao direito de interpretação final do evento.",
            "ru": "1. Нажмите на значок внизу, чтобы выбрать элемент для размещения. Нажмите на нужную клетку, чтобы его разместить.<p></p>\n2. Чтобы удалить размещенный элемент, нажмите «Убрать», а затем нажмите на клетку.<p></p>\n3. На карте обязательно должны быть кристаллы и выходы монстров. Точек появления монстров может быть несколько.<p></p>\n4. Кристаллы и выходы для монстров нельзя закрывать препятствиями.<p></p>\n5. Препятствия нельзя размещать на расстоянии 2 или менее клеток от кристаллов и 1 или менее клеток от выходов монстров.<p></p>\n6. Во время события можно отправить несколько карт, но награду вы сможете получить только один раз. Конечно, если мы используем вашу карту лабиринта, вас ждет бонусная награда!<p></p>\n7. Habby оставляет за собой право окончательной интерпретации события.",
            "es": "1. Toca el ícono inferior para elegir un elemento a colocar y luego toca el cuadrado donde quieras colocarlo.<p></p>\n2. Toca el botón Eliminar y luego toca el cuadrado cuyo elemento ya colocado quieras eliminar.<p></p>\n3. Los cristales y las salidas de monstruos son obligatorias. Puede haber múltiples puntos de generación de monstruos.<p></p>\n4. Los cristales y las salidas de los monstruos no se pueden sellar con obstáculos.<p></p>\n5. No se pueden colocar obstáculos a menos de 2 cuadrados de distancia de cristales y 1 cuadrados de distancia de salidas de monstruos.<p></p>\n6. Durante el evento, puedes enviar varios diseños pero recibirás tu recompensa solo una vez. ¡Por supuesto, si usamos tu diseño de laberinto, te enviaremos recompensas de bonificación!<p></p>\n7. Habby se reserva el derecho de interpretación final del evento.",
            "th": "1. แตะไอคอนด้านล่างสุดเพื่อเลือกธาตุที่จะวาง จากนั้นแตะที่สี่เหลี่ยมจัตุรัสที่คุณเลือกเพื่อวางมัน<p></p>\n2. แตะปุ่มเอาออก จากนั้นแตะสี่เหลี่ยมจัตุรัสเพื่อเอาธาตุที่วางแล้วออก<p></p>\n3. คริสตัลและมอนสเตอร์ออกเป็นตัวเลือกบังคับ สามารถมีจุดเกิดมอนสเตอร์ได้หลายจุด<p></p>\n4. คริสตัลและมอนสเตอร์ออกไม่สามารถใช้สิ่งกีดขวางปิดผนึกได้<p></p>\n5. ไม่สามารถวางสิ่งกีดขวางภายใน 2 สี่เหลี่ยมจัตุรัสของคริสตัลและ 1 สี่เหลี่ยมจัตุรัสของมอนสเตอร์ออกได้<p></p>\n6. ในระหว่างอีเวนต์ คุณสามารถส่งดีไซน์ได้หลายชิ้น แต่จะได้รับรางวัลเพียงครั้งเดียวเท่านั้น แน่นอนว่าถ้าเราใช้ดีไซน์เขาวงกตของคุณ เราจะส่งรางวัลโบนัสไปให้!<p></p>\n7. Habby สงวนสิทธิ์ในการตีความขั้นสุดท้ายของอีเวนต์",
            "vi": "1. Nhấp vào biểu tượng ở dưới cùng để chọn nguyên tố, sau đó nhấp vào ô bạn muốn để đặt nó.<p></p>\n2. Nhấp vào nút Loại bỏ, sau đó chọn ô muốn xóa nguyên tố đã đặt.<p></p>\n3. Tinh thể và Lối thoát quái vật là những lựa chọn bắt buộc. Có thể có nhiều điểm sinh ra quái vật.<p></p>\n4. Không thể dùng chướng ngại vật để chặn tinh thể và lối thoát quái vật.<p></p>\n5. Không thể đặt các chướng ngại vật trong vòng 2 ô tinh thể và 1 ô lối thoát quái vật.<p></p>\n6. Trong thời gian diễn ra sự kiện, bạn có thể gửi nhiều bản thiết kế, nhưng chỉ được nhận thưởng một lần duy nhất. Tất nhiên, nếu sử dụng bản thiết kế mê cung của bạn thì chúng tôi sẽ gửi thêm phần thưởng cho bạn!<p></p>\n7. Habby bảo lưu quyền giải thích cuối cùng cho sự kiện này.",
            "it": "1. Tocca l'icona in basso per scegliere un elemento da posizionare, quindi tocca un quadrato a tua scelta per posizionarlo.<p></p>\n2. Tocca il pulsante Rimuovi, quindi tocca un quadrato per rimuovere un elemento posizionato.<p></p>\n3. I Cristalli e le Uscite dai mostri sono scelte obbligate. I punti di generazione dei mostri possono essere molteplici.<p></p>\n4. I Cristalli e le Uscite dei mostri non possono essere chiusi con gli Ostacoli.<p></p>\n5. Gli Ostacoli non possono essere posizionati entro 2 caselle dai Cristalli e 1 caselle dai dalle Uscite dei mostri.<p></p>\n6. Durante l'evento puoi inviare più progetti, ma riceverai il premio una sola volta. Ovviamente, se utilizzeremo il tuo progetto di labirinto, ti invieremo altri premi!<p></p>\n7. Habby si riserva il diritto di interpretazione finale in merito all'evento.",
            "tr": "1. Yerleştirilecek elementi seçmek için alttaki butona dokun, daha sonra yerleştirmek istediğin kareye dokun.<p></p>\n2. Yerleştirilen bir elementi kaldırmak için Kaldır butonuna dokun.<p></p>\n3. Kristaller ve canavar çıkışları zorunlu seçimlerdir. Çok sayıda canavar çıkış noktası olabilir.<p></p>\n4. Engelleri kullanarak kristalleri ve canavar çıkışlarını kapatamazsın.<p></p>\n5. Engelleri kristallerin 2 kare ve canavar çıkışlarının 1 kare yakınına yerleştiremezsin.<p></p>\n6. Etkinlik sırasında birden çok tasarım gönderebilirsin ama ödülünü yalnızca bir kez alırsın. Elbette, tasarladığın labirenti kullanırsak bonus ödüller seni bekliyor!<p></p>\n7. Habby etkinliğin koşullarını nihai yorum hakkını saklı tutar."
        },
        {
            "field1": "",
            "ID": "2",
            "zh-CN": "关闭",
            "字节限制": "",
            "备注": "规则页",
            "zh-TW": "關閉",
            "en": "Close",
            "ar": "إغلاق",
            "fr": "Fermer",
            "de": "Schließen",
            "id": "Tutup",
            "ja": "閉じる",
            "ko": "닫기",
            "pt": "Fechar",
            "ru": "Закрыть",
            "es": "Cerrar",
            "th": "ปิด",
            "vi": "Đóng",
            "it": "Chiudi",
            "tr": "Kapat"
        },
        {
            "field1": "",
            "ID": "3",
            "zh-CN": "必选",
            "字节限制": "",
            "备注": "",
            "zh-TW": "必選",
            "en": "Mandatory",
            "ar": "إلزامي",
            "fr": "Obligatoire",
            "de": "Verpflichtend",
            "id": "Wajib",
            "ja": "必須",
            "ko": "필수",
            "pt": "Obrigatório",
            "ru": "Обязательно",
            "es": "Obligatorio",
            "th": "บังคับ",
            "vi": "Bắt buộc",
            "it": "Obbligatorio",
            "tr": "Zorunlu"
        },
        {
            "field1": "",
            "ID": "4",
            "zh-CN": "水晶",
            "字节限制": "",
            "备注": "",
            "zh-TW": "水晶",
            "en": "Crystal",
            "ar": "بلورة",
            "fr": "Cristal",
            "de": "Kristall",
            "id": "Kristal",
            "ja": "クリスタル",
            "ko": "크리스탈",
            "pt": "Cristal",
            "ru": "Кристалл",
            "es": "Cristal",
            "th": "คริสตัล",
            "vi": "Tinh Thể",
            "it": "Cristallo",
            "tr": "Kristal"
        },
        {
            "field1": "",
            "ID": "5",
            "zh-CN": "怪物出口",
            "字节限制": "",
            "备注": "",
            "zh-TW": "怪物出口",
            "en": "Monster Exit",
            "ar": "مخرج الوحش",
            "fr": "Sortie de monstre",
            "de": "Monster ausgang",
            "id": "Pintu Keluar Monster",
            "ja": "モンスター 出口",
            "ko": "몬스터 출구",
            "pt": "Saída do monstro",
            "ru": "Выход монстров",
            "es": "Salida de monstruo",
            "th": "มอนสเตอร์ออก",
            "vi": "Lối Thoát Quái Vật",
            "it": "Uscita del mostro",
            "tr": "Canavar Çıkışı"
        },
        {
            "field1": "",
            "ID": "6",
            "zh-CN": "水池",
            "字节限制": "",
            "备注": "",
            "zh-TW": "水池",
            "en": "Water Pool",
            "ar": "بركة مياه",
            "fr": "Piscine",
            "de": "Wasser becken",
            "id": "Kolam Air",
            "ja": "プール",
            "ko": "물웅덩이",
            "pt": "Piscina de água",
            "ru": "Водоем",
            "es": "Piscina",
            "th": "สระน้ำ",
            "vi": "Hồ Nước",
            "it": "Pozza d'acqua",
            "tr": "Havuz"
        },
        {
            "field1": "",
            "ID": "7",
            "zh-CN": "墙",
            "字节限制": "",
            "备注": "",
            "zh-TW": "牆",
            "en": "Wall",
            "ar": "جدار",
            "fr": "Mur",
            "de": "Wand",
            "id": "Tembok",
            "ja": "壁",
            "ko": "벽",
            "pt": "Muro",
            "ru": "Стена",
            "es": "Pared",
            "th": "กำแพง",
            "vi": "Tường Thành",
            "it": "Muro",
            "tr": "Duvar"
        },
        {
            "field1": "",
            "ID": "8",
            "zh-CN": "擦除",
            "字节限制": "",
            "备注": "",
            "zh-TW": "擦除",
            "en": "Remove",
            "ar": "إزالة",
            "fr": "Retirer",
            "de": "Entfernen",
            "id": "Hapus",
            "ja": "消去",
            "ko": "삭제",
            "pt": "Remover",
            "ru": "Убрать",
            "es": "Eliminar",
            "th": "เอาออก",
            "vi": "Loại bỏ",
            "it": "Rimuovi",
            "tr": "Kaldır"
        },
        {
            "field1": "",
            "ID": "9",
            "zh-CN": "提交",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交",
            "en": "Submit",
            "ar": "إرسال",
            "fr": "Envoyer",
            "de": "Einreichen",
            "id": "Kirim",
            "ja": "提出する",
            "ko": "제출",
            "pt": "Enviar",
            "ru": "Отправить",
            "es": "Enviar",
            "th": "ส่ง",
            "vi": "Gửi",
            "it": "Invia",
            "tr": "Gönder"
        },
        {
            "field1": "",
            "ID": "10",
            "zh-CN": "活动期间您可以提交多份设计稿，但只会收到一次奖励。<p></p>\n首次提交完成后，您将于游戏内收到一封奖励邮件。",
            "字节限制": "",
            "备注": "",
            "zh-TW": "活动期间您可以提交多份设计稿，但只会收到一次奖励。<p></p>\n首次提交完成後，您將在遊戲內收到一封獎勵郵件。",
            "en": "During the event, you can submit multiple designs.<p></p>\nUpon your first submission, you will receive a reward in your in-game mail.",
            "ar": "خلال الفعالية، يمكنك إرسال عدة تصاميم.<p></p>\nعند إرسال تصميمك الأول، ستحصل على مكافأة في بريدك داخل اللعبة.",
            "fr": "Pendant l'événement, vous pouvez envoyer plusieurs designs.<p></p>\nLors de votre premier envoi, vous recevrez une récompense par e-mail dans le jeu.",
            "de": "Während des Events kannst du mehrere Entwürfe einreichen.<p></p>\nBei deiner ersten Einreichung erhältst du per Mail im Spiel eine Belohnung.",
            "id": "Selama event, kamu bisa mengirim beberapa desain.<p></p>\nSetelah pengiriman pertamamu, kamu akan menerima hadiah di pesan dalam game kamu.",
            "ja": "イベント期間中に複数件のデザインをご提出できます。<p></p>\n初回提出後と、ゲーム内で報酬メールが届きます。",
            "ko": "이벤트 기간 중 여러 디자인을 제출할 수 있습니다.<p></p>\n처음 제출 완료 후 게임 내에서 메일을 받습니다.",
            "pt": "Durante o evento, você pode enviar vários designs.<p></p>\nApós o primeiro envio, você receberá uma recompensa em seu correio no jogo.",
            "ru": "Во время события можно отправить несколько карт.<p></p>\nОтправив карту впервые, вы получите награду по игровой почте.",
            "es": "Durante el evento, puedes enviar varios diseños.<p></p>\nLa primera vez que envíes, recibirás una recompensa en tu correo interno.",
            "th": "ในระหว่างอีเวนต์ คุณสามารถส่งดีไซน์ได้หลายชิ้น<p></p>\nเมื่อส่งครั้งแรก คุณจะได้รับรางวัลในจดหมายในเกมของคุณ",
            "vi": "Trong thời gian diễn ra sự kiện, bạn có thể gửi nhiều bản thiết kế.<p></p>\nSau lần gửi đầu tiên, bạn sẽ được nhận thưởng qua thư trong game.",
            "it": "Durante l'evento, puoi inviare più progetti.<p></p>\nAl primo invio riceverai un premio tramite posta di gioco.",
            "tr": "Etkinlik sırasında birden çok tasarım gönderebilirsin.<p></p>\nİlk gönderimini yaptıktan sonra ödülün oyundaki posta kutuna gönderilir."
        },
        {
            "field1": "",
            "ID": "11",
            "zh-CN": "上一步",
            "字节限制": "",
            "备注": "",
            "zh-TW": "上一步",
            "en": "Back",
            "ar": "رجوع",
            "fr": "Retour",
            "de": "Zurück",
            "id": "Kembali",
            "ja": "前へ",
            "ko": "뒤로",
            "pt": "Voltar",
            "ru": "Назад",
            "es": "Volver",
            "th": "ย้อนกลับ",
            "vi": "Trở lại",
            "it": "Indietro",
            "tr": "Geri"
        },
        {
            "field1": "",
            "ID": "12",
            "zh-CN": "游戏ID",
            "字节限制": "",
            "备注": "",
            "zh-TW": "遊戲ID",
            "en": "Game ID",
            "ar": "مُعَرِّف المباراة",
            "fr": "ID de jeu",
            "de": "Spiel-ID",
            "id": "ID Game",
            "ja": "プレイヤーID",
            "ko": "게임 ID",
            "pt": "ID do jogo",
            "ru": "Идентификатор",
            "es": "ID del juego",
            "th": "ไอดีเกม",
            "vi": "ID trò chơi",
            "it": "ID del gioco",
            "tr": "Oyun Kimliği"
        },
        {
            "field1": "",
            "ID": "13",
            "zh-CN": "请在此输入游戏ID",
            "字节限制": "",
            "备注": "",
            "zh-TW": "請在此輸入遊戲ID",
            "en": "Enter your Game ID here",
            "ar": "أدخل مُعَرِّف المباراة هنا",
            "fr": "Saisissez votre ID de jeu ici",
            "de": "Gib hier deine Spiel-ID ein",
            "id": "Masukkan ID Game kamu di sini",
            "ja": "プレイヤーIDを入力してください",
            "ko": "게임 ID를 입력하세요",
            "pt": "Insira seu ID do jogo aqui",
            "ru": "Введите свой идентификатор здесь",
            "es": "Introduce tu ID del juego aquí",
            "th": "กรอกไอดีเกมของคุณที่นี่",
            "vi": "Nhập ID trò chơi của bạn tại đây",
            "it": "Inserisci qui l'ID del gioco",
            "tr": "Oyun Kimliğinizi girin"
        },
        {
            "field1": "",
            "ID": "14",
            "zh-CN": "验证码",
            "字节限制": "",
            "备注": "",
            "zh-TW": "驗證碼",
            "en": "Verification Code",
            "ar": "رمز التحقق",
            "fr": "Code de vérification",
            "de": "Bestätigungscode",
            "id": "Kode Verifikasi",
            "ja": "認証コード",
            "ko": "인증 코드",
            "pt": "Código de verificação",
            "ru": "Код верификации",
            "es": "Código de verificación",
            "th": "รหัสยืนยัน",
            "vi": "Mã xác thực",
            "it": "Codice di verifica",
            "tr": "Doğrulama Kodu"
        },
        {
            "field1": "",
            "ID": "15",
            "zh-CN": "点击图片以刷新验证码",
            "字节限制": "",
            "备注": "",
            "zh-TW": "點擊圖片以刷新驗證碼",
            "en": "Tap the image to refresh the code",
            "ar": "اضغط على الصورة لتحديث الرمز",
            "fr": "Tapez sur l'image pour actualiser le code",
            "de": "Tippe auf das Bild, um den Code zu aktualisieren",
            "id": "Sentuh gambar untuk memperbarui kode",
            "ja": "画像クリックで認証コードを更新できます",
            "ko": "이미지를 클릭하면 인증코드가 새로고침 됩니다.",
            "pt": "Toque a imagem para atualizar o código",
            "ru": "Для обновления кода нажмите на изображение",
            "es": "Toca la imagen para actualizar el código",
            "th": "แตะรูปภาพเพื่อรีเฟรชรหัส",
            "vi": "Nhấn vào hình để làm mới mã",
            "it": "Tocca l'immagine per aggiornare il codice",
            "tr": "Kodu yenilemek için görsele dokunun"
        },
        {
            "field1": "",
            "ID": "16",
            "zh-CN": "橡皮",
            "字节限制": "",
            "备注": "",
            "zh-TW": "橡皮",
            "en": "Eraser",
            "ar": "الممحاة",
            "fr": "Gomme",
            "de": "Radierer",
            "id": "Penghapus",
            "ja": "消しゴム",
            "ko": "지우개",
            "pt": "Apagador",
            "ru": "Ластик",
            "es": "Borrador",
            "th": "ยางลบ",
            "vi": "Tẩy",
            "it": "Gomma",
            "tr": "Silgi"
        },
        {
            "field1": "",
            "ID": "17",
            "zh-CN": "已选中水晶",
            "字节限制": "",
            "备注": "",
            "zh-TW": "已選中水晶",
            "en": "Crystal selected.",
            "ar": "تم تحديد البلُّورة",
            "fr": "Cristal sélectionné.",
            "de": "Kristall ausgewählt.",
            "id": "Kristal dipilih.",
            "ja": "クリスタルを選択中です。",
            "ko": "선택된 크리스탈",
            "pt": "Cristal selecionado.",
            "ru": "Выбран кристалл.",
            "es": "Cristal seleccionado.",
            "th": "เลือกคริสตัลแล้ว",
            "vi": "Đã chọn Tinh Thể",
            "it": "Cristallo selezionato.",
            "tr": "Kristal seçildi."
        },
        {
            "field1": "",
            "ID": "18",
            "zh-CN": "已选中怪物出口",
            "字节限制": "",
            "备注": "",
            "zh-TW": "已選中怪物出口",
            "en": "Monster Exit selected.",
            "ar": "تم تحديد مخرج الوحش",
            "fr": "Sortie de monstre sélectionnée.",
            "de": "Monsterausgang ausgewählt.",
            "id": "Pintu Keluar Monster dipilih.",
            "ja": "モンスター出口を選択中です。",
            "ko": "몬스터 출구가 선택됨",
            "pt": "Saída do monstro selecionada.",
            "ru": "Выбран выход монстров.",
            "es": "Salida de monstruo seleccionada.",
            "th": "เลือกมอนสเตอร์ออกแล้ว",
            "vi": "Đã chọn Lối Thoát Quái Vật",
            "it": "Uscita del mostro selezionata.",
            "tr": "Canavar Çıkışı seçildi."
        },
        {
            "field1": "",
            "ID": "19",
            "zh-CN": "已选中水池",
            "字节限制": "",
            "备注": "",
            "zh-TW": "已選中水池",
            "en": "Water Pool selected.",
            "ar": "تم تحديد بركة مياه",
            "fr": "Piscine sélectionnée.",
            "de": "Wasserbecken ausgewählt.",
            "id": "Kolam Air dipilih.",
            "ja": "プールを選択中です。",
            "ko": "물웅덩이가 선택됨",
            "pt": "Piscina de água selecionada.",
            "ru": "Выбран водоем.",
            "es": "Piscina seleccionada.",
            "th": "เลือกสระน้ำแล้ว",
            "vi": "Đã chọn Hồ Nước",
            "it": "Pozza d'acqua selezionata.",
            "tr": "Havuz seçildi."
        },
        {
            "field1": "",
            "ID": "20",
            "zh-CN": "已选中墙",
            "字节限制": "",
            "备注": "",
            "zh-TW": "已選中牆",
            "en": "Wall selected.",
            "ar": "تم تحديد جدار",
            "fr": "Mur sélectionné.",
            "de": "Wand ausgewählt.",
            "id": "Tembok dipilih.",
            "ja": "壁を選択中です。",
            "ko": "선택된 벽",
            "pt": "Muro selecionado.",
            "ru": "Выбрана стена.",
            "es": "Pared seleccionada.",
            "th": "เลือกกำแพงแล้ว",
            "vi": "Đã chọn Tường Thành",
            "it": "Muro selezionato.",
            "tr": "Duvar seçildi."
        },
        {
            "field1": "",
            "ID": "21",
            "zh-CN": "您只能放置1个水晶",
            "字节限制": "",
            "备注": "",
            "zh-TW": "您只能放置1個水晶",
            "en": "You may only place 1 crystal.",
            "ar": "يمكنك وضع بلورة واحدة فقط",
            "fr": "Vous ne pouvez placer que 1 cristal.",
            "de": "Du kannst nur 1 Kristall platzieren.",
            "id": "Kamu hanya bisa meletakkan 1 kristal.",
            "ja": "クリスタルは1つのみ配置可能です。",
            "ko": "1개의 크리스탈만 놓을 수 있습니다.",
            "pt": "Você pode colocar apenas um cristal.",
            "ru": "Вы можете разместить только 1 кристалл.",
            "es": "Solo puedes colocar 1 cristal.",
            "th": "คุณสามารถวางคริสตัลได้เพียง 1 อันเท่านั้น",
            "vi": "Bạn chỉ có thể đặt 1 pha lê",
            "it": "Puoi posizionare solo 1 cristallo.",
            "tr": "Yalnızca bir kristal yerleştirebilirsiniz."
        },
        {
            "field1": "",
            "ID": "22",
            "zh-CN": "提交失败：游戏ID错误！",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交失敗：遊戲ID錯誤！",
            "en": "Failed to submit: Game ID error!",
            "ar": "تعذر الإرسال: خطأ في معرف اللعبة!",
            "fr": "Échec de l’envoi : erreur de l’ID de jeu !",
            "de": "Einreichen fehlgeschlagen: Spiel-ID-Fehler!",
            "id": "Gagal mengirim: Kesalahan ID Game!",
            "ja": "送信に失敗しました：ゲームIDエラー！",
            "ko": "제출 실패: 게임 ID 오류!",
            "pt": "Falha ao enviar: erro de ID de jogo!",
            "ru": "Отправить не удалось: ошибка игрового ID!",
            "es": "¡Fallo al enviar: Error de ID del juego!",
            "th": "ล้มเหลวในการส่ง: ID เกมผิดพลาด!",
            "vi": "Gửi thất bại: Lỗi ID trò chơi!",
            "it": "Invio non riuscito: errore dell'ID del gioco!",
            "tr": "Gönderilemedi: Oyun Kimliği hatası!"
        },
        {
            "field1": "",
            "ID": "23",
            "zh-CN": "提交失败：验证码错误！",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交失敗：驗證碼錯誤！",
            "en": "Failed to submit: Verification code error!",
            "ar": "خطأ في الإرسال: خطأ في رمز التحقق!",
            "fr": "Échec de l’envoi : erreur du code de vérification !",
            "de": "Einreichen fehlgeschlagen: Verifizierungscode-Fehler!",
            "id": "Gagal mengirim: Kesalahan kode verifikasi!",
            "ja": "送信に失敗しました：検証コードエラー！",
            "ko": "제출 실패: 인증 코드 오류!",
            "pt": "Falha ao enviar: erro de código de verificação!",
            "ru": "Отправить не удалось: ошибка кода подтверждения!",
            "es": "¡Fallo al enviar: Error de código de verificación!",
            "th": "ล้มเหลวในการส่ง: รหัสการยืนยันผิดพลาด!",
            "vi": "Gửi thất bại: Lỗi mã xác minh!",
            "it": "Invio non riuscito: errore del codice di verifica!",
            "tr": "Gönderilemedi: Doğrulama kodu hatası!"
        },
        {
            "field1": "",
            "ID": "24",
            "zh-CN": "服务器繁忙，请重试。",
            "字节限制": "",
            "备注": "",
            "zh-TW": "伺服器繁忙，請重試。",
            "en": "Server is busy, please retry.",
            "ar": "الخادم مشغول، يُرجى إعادة المحاولة.",
            "fr": "Le serveur est occupé, veuillez réessayer.",
            "de": "Server ist voll, bitte erneut versuchen.",
            "id": "Server sibuk, harap coba lagi.",
            "ja": "サーバーがビジー状態です。再試行してください。",
            "ko": "서버 사용량이 많습니다. 다시 시도해 주세요.",
            "pt": "O servidor está ocupado. Tente novamente.",
            "ru": "Сервер занят; попробуйте еще раз.",
            "es": "El servidor está ocupado, vuelve a intentarlo.",
            "th": "เซิร์ฟเวอร์ไม่ว่าง โปรดลองใหม่",
            "vi": "Máy chủ đang bận, vui lòng thử lại.",
            "it": "Il server è occupato, riprova.",
            "tr": "Sunucu meşgul, lütfen yeniden dene."
        },
        {
            "field1": "",
            "ID": "25",
            "zh-CN": "提交成功！",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交成功！",
            "en": "Submitted successfully!",
            "ar": "تم الإرسال بنجاح!",
            "fr": "Envoi réussi !",
            "de": "Erfolgreich eingereicht!",
            "id": "Berhasil dikirimkan!",
            "ja": "送信が成功しました！",
            "ko": "제출 성공!",
            "pt": "Envio realizado com sucesso!",
            "ru": "Успешно отправлено!",
            "es": "¡Enviado correctamente!",
            "th": "ส่งสำเร็จแล้ว!",
            "vi": "Đã gửi thành công!",
            "it": "Inviato correttamente!",
            "tr": "Gönderim başarılı!"
        },
        {
            "field1": "",
            "ID": "26",
            "zh-CN": "提交失败：参数错误！",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交失敗：參數錯誤！",
            "en": "Failed to submit: Parameter error!",
            "ar": "تعذر الإرسال: خطأ في المعطيات!",
            "fr": "Échec de l’envoi : erreur de paramètre !",
            "de": "Einreichen fehlgeschlagen: Parameterfehler!",
            "id": "Gagal mengirim: Kesalahan parameter!",
            "ja": "送信に失敗しました：パラメーターエラー！",
            "ko": "제출 실패: 파라미터 오류!",
            "pt": "Falha ao enviar: erro de parâmetro!",
            "ru": "Отправить не удалось: ошибка параметров!",
            "es": "¡Fallo al enviar: Error de parámetro!",
            "th": "ล้มเหลวในการส่ง: พารามิเตอร์ผิดพลาด!",
            "vi": "Gửi thất bại: Lỗi tham số!",
            "it": "Invio non riuscito: Errore di parametro!",
            "tr": "Gönderilemedi: Parametre hatası!"
        },
        {
            "field1": "",
            "ID": "27",
            "zh-CN": "提交失败：缺少怪物出口",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交失敗：缺少怪物出口",
            "en": "Failed to submit: Insufficient Monster exit",
            "ar": "تعذر الإرسال: مَخرج الوحش غير كافٍ",
            "fr": "Échec de l'envoi : sortie de monstre insuffisante",
            "de": "Einreichen fehlgeschlagen: Unzureichender Monsterausgang",
            "id": "Gagal mengirim: Kekurangan Pintu Keluar Monster",
            "ja": "送信に失敗しました：モンスター出口不足",
            "ko": "제출 실패: 몬스터 출구 부족",
            "pt": "Falha ao enviar: Saída de Monstro insuficiente",
            "ru": "Отправить не удалось: недостаточно Выходов монстров",
            "es": "Fallo al enviar: No hay suficientes Salidas de monstruo",
            "th": "ล้มเหลวในการส่ง: ขาดมอนสเตอร์ออก",
            "vi": "Gửi thất bại: Thiếu Lối Thoát Quái Vật",
            "it": "Invio non riuscito: Uscita del mostro non sufficiente",
            "tr": "Gönderilemedi: Canavar Çıkışı eksik"
        },
        {
            "field1": "",
            "ID": "28",
            "zh-CN": "提交失败：缺少水晶",
            "字节限制": "",
            "备注": "",
            "zh-TW": "提交失敗：缺少水晶",
            "en": "Failed to submit: Insufficient Crystal",
            "ar": "تعذر الإرسال: البلُّورة غير كافية",
            "fr": "Échec de l'envoi : Cristal insuffisant",
            "de": "Einreichen fehlgeschlagen: Unzureichender Kristall",
            "id": "Gagal mengirim: Kekurangan Kristal",
            "ja": "送信に失敗しました：クリスタル不足",
            "ko": "제출 실패: 크리스탈 부족",
            "pt": "Falha ao enviar: Cristal insuficiente",
            "ru": "Отправить не удалось: недостаточно Кристаллов",
            "es": "Fallo al enviar: No hay suficientes Cristal",
            "th": "ล้มเหลวในการส่ง: ขาดคริสตัล",
            "vi": "Gửi thất bại: Thiếu Tinh Thể",
            "it": "Invio non riuscito: Cristallo non sufficiente",
            "tr": "Gönderilemedi: Kristal eksik"
        },
        {
            "field1": "",
            "ID": "29",
            "zh-CN": "怪物出口周围半径1格内无法放置障碍物",
            "字节限制": "",
            "备注": "",
            "zh-TW": "怪物出口周圍半徑1格內無法放置障礙物",
            "en": "Obstacles not allowed within a 1-tile radius of any Monster exit",
            "ar": "لا يُسمح لك بوضع أي عوائق مُحددة على مسافة 1 بلاطات من مَخرج الوحش.",
            "fr": "Les obstacles ne sont pas autorisés dans un rayon de 1 cases d'une sortie de monstre",
            "de": "Hindernisse in einem Radius von 1 Feldern um einen Monsterausgang nicht erlaubt",
            "id": "Rintangan tidak boleh ditempatkan dalam radius 1 blok dari Pintu Keluar Monster.",
            "ja": "モンスター出口の周囲1マス以内には障害物の配置不可",
            "ko": "괴물 출구 주변 1 타일 내 장애물 배치 불가",
            "pt": "Obstáculos não permitidos dentro de um raio de 1 espaços de qualquer Saída de Monstro",
            "ru": "В радиусе 1 клеток от любого Выхода монстров не должно быть препятствий",
            "es": "No se permiten obstáculos dentro de un radio de 1 losetas de cualquier Salida de monstruo",
            "th": "ไม่สามารถวางสิ่งกีดขวางในรัศมี 1 ช่องรอบ ๆ มอนสเตอร์ออกได้",
            "vi": "Không thể đặt chướng ngại vật trong bán kính 1 ô xung quanh Lối Thoát Quái Vật",
            "it": "Ostacoli non ammessi all'interno di un raggio di 1 tessere da qualsiasi Uscita del mostro",
            "tr": "Herhangi bir Canavar çıkışının 1 karoluk yarıçapı içinde engellere izin verilmez"
        },
        {
            "field1": "",
            "ID": "30",
            "zh-CN": "水晶周围半径2格内无法放置障碍物",
            "字节限制": "",
            "备注": "",
            "zh-TW": "水晶周圍半徑2格內無法放置障礙物",
            "en": "Obstacles not allowed within a 2-tile radius of the Crystal",
            "ar": "لا يُسمح لك بوضع أي عوائق مُحددة على مسافة 2 بلاطات من البلُّورة.",
            "fr": "Les obstacles ne sont pas autorisés dans un rayon de 2 cases du Cristal",
            "de": "Hindernisse in einem Radius von 2 Feldern um den Kristall nicht erlaubt",
            "id": "Rintangan tidak boleh ditempatkan dalam radius 2 blok dari Kristal.",
            "ja": "クリスタルの周囲2マス以内には障害物の配置不可",
            "ko": "크리스탈 주변 2 타일 내 장애물 배치 불가",
            "pt": "Obstáculos não permitidos dentro de um raio de 2 espaços do Cristal",
            "ru": "В радиусе 2 клеток от любого Кристалла не должно быть препятствий",
            "es": "No se permiten obstáculos dentro de un radio de 2 losetas de cualquier Cristal",
            "th": "ไม่สามารถวางสิ่งกีดขวางในรัศมี 2 กริดรอบคริสตัลได้",
            "vi": "Không thể đặt chướng ngại vật trong bán kính 2 ô xung quanh Tinh Thể",
            "it": "Ostacoli non ammessi all'interno di un raggio di 2 tessere dal Cristallo",
            "tr": "Kristalin 2 karoluk yarıçapı içinde engellere izin verilmez"
        },
        {
            "field1": "",
            "ID": "31",
            "zh-CN": "隐藏",
            "字节限制": "",
            "备注": "",
            "zh-TW": "隱藏",
            "en": "Hide",
            "ar": "يخفي",
            "fr": "Cacher",
            "de": "Ausblenden",
            "id": "Sembunyi",
            "ja": "非表示",
            "ko": "숨기기",
            "pt": "Esconder",
            "ru": "Скрыть",
            "es": "Ocultar",
            "th": "ซ่อน",
            "vi": "Trốn",
            "it": "Nascondi",
            "tr": "Gizle"
        },
        {
            "field1": "",
            "ID": "32",
            "zh-CN": "显示",
            "字节限制": "",
            "备注": "",
            "zh-TW": "顯示",
            "en": "Show",
            "ar": "يعرض",
            "fr": "Afficher",
            "de": "Anzeigen",
            "id": "Tampilkan",
            "ja": "表示",
            "ko": "표시",
            "pt": "Mostrar",
            "ru": "Показать",
            "es": "Mostrar",
            "th": "แสดง",
            "vi": "Trình diễn",
            "it": "Mostra",
            "tr": "Göster"
        },
        {
            "field1": "",
            "ID": "33",
            "zh-CN": "请输入ID",
            "字节限制": "",
            "备注": "",
            "zh-TW": "請輸入ID",
            "en": "Enter the correct Game ID",
            "ar": "Enter the correct Game ID",
            "fr": "Enter the correct Game ID",
            "de": "Enter the correct Game ID",
            "id": "Enter the correct Game ID",
            "ja": "正しいゲームIDを入力してください",
            "ko": "올바른 게임ID를 입력하세요",
            "pt": "Enter the correct Game ID",
            "ru": "Введите верный ID игрока",
            "es": "Enter the correct Game ID",
            "th": "Enter the correct Game ID",
            "vi": "Enter the correct Game ID",
            "it": "Enter the correct Game ID",
            "tr": "Enter the correct Game ID"
        },
        {
            "field1": "",
            "ID": "34",
            "zh-CN": "请输入验证码",
            "字节限制": "",
            "备注": "",
            "zh-TW": "請輸入驗證碼",
            "en": "Enter the correct Verification Code",
            "ar": "Enter the correct Verification Code",
            "fr": "Enter the correct Verification Code",
            "de": "Enter the correct Verification Code",
            "id": "Enter the correct Verification Code",
            "ja": "正しい確認コードを入力してください",
            "ko": "올바른 확인 코드를 입력하세요",
            "pt": "Enter the correct Verification Code",
            "ru": "Введите верный код подтверждения",
            "es": "Enter the correct Verification Code",
            "th": "Enter the correct Verification Code",
            "vi": "Enter the correct Verification Code",
            "it": "Enter the correct Verification Code",
            "tr": "Enter the correct Verification Code"
        }
    ]



// WEBPACK FOOTER //
// ./src/tool/lang.js